export enum EPageActionTypes {
  SetPageType = 'PAGE/SET_PAGE_TYPE',
  SetPageQueryParams = 'PAGE/SET_PAGE_QUERY_PARAMS',
  ToggleStickyScrollBtn = 'PAGE/TOOGLE_STICKY_SCROOL_BTN',
}

export enum EPageType {
  /* Собственник */
  Homeowner = 'Landlord',
  /* Квартиросъемщик */
  Tenant = 'Renter',
  /* Риелтор */
  Agent = 'Agent',
}

export type TQueryParams = {
  source?: string;
  dealtype?: EPageType;
};

export type TPage = {
  pageType: EPageType;
  queryParams: TQueryParams;
  isWebview?: boolean;
  isStickyBtnVisible: boolean;
};
